<template>
  <div>
    <div class="card-content">
      <div class="buttons">
        <button
          @click="select(year)"
          v-for="year in data"
          :key="year"
          class="button"
          :class="{ 'is-soft': isSelected(year) }"
        >
          {{ year }}
        </button>
      </div>
    </div>
    <div class="card-footer has-background-white">
      <div class="column is-12">
        <div class="columns is-mobile">
          <div class="column">
            <a v-if="itemCount" class="has-text-danger" @click="clearFilters">
              Reset
            </a>
            <p v-else class="has-text-grey-light">Reset</p>
          </div>
          <div class="column is-narrow">
            <p v-if="years.length">{{ itemCount }} selected</p>
            <p v-else class="has-text-grey-light">No items selected</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'StockviewRegistrationFilter',
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({ years: [] }),
  watch: {
    years: 'setFilterState'
  },
  mounted() {
    if (this.filters.registrationYear) {
      this.years = this.filters.registrationYear
    }
  },
  computed: {
    ...mapGetters('stockview/listings', ['filters', 'filterOptions']),
    itemCount() {
      const count = this.years.length
      return count === 1 ? '1 item' : `${count} items`
    }
  },
  methods: {
    ...mapActions('stockview/listings', ['updateFilters']),
    track(action) {
      this.$mxp.track(`stockview_stock_${action}_registration_year_filter`)
    },
    select(year) {
      if (this.years.includes(year)) {
        this.track('remove')
        this.years = this.years.filter(element => element !== year)
      } else {
        this.track('add')
        this.years.push(year)
      }
    },
    setFilterState() {
      const type = 'registrationYear'
      this.updateFilters({
        filters: [{ type, payload: this.years }],
        count: this.years.length,
        type
      })
    },
    isSelected(year) {
      return this.years.includes(year)
    },
    clearFilters() {
      this.track('reset')
      this.years = []
    }
  }
}
</script>
